 <template>
    <div class="header_container" style="background-color:#fff;opacity:1">
    <van-row type="flex"  justify="space-between" style="height: 40px;">
      <van-row type = "flex" style ="margin:2px" >
        <div><van-image width="40px" :src =" logo"/></div>
        <div class="grid-content"><div>天津大学浙江研究院</div><div>实验室安全教育培训与管理系统</div></div>
      </van-row>
      <div>
        <van-tag type="warning" style="margin-top : 25px"> {{ userInfo.fullName  }} </van-tag>
        <van-tag type="danger" @click="doLogout" style="margin-top : 25px;margin-right: 2px;"> 退出 </van-tag>
      </div>
    </van-row>
    <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0', margin:'2px' }">
    </van-divider>
    </div>
</template>

<script>
  import logo from "@/assets/image/yuanhui.png"
  import axios from  '@/api/axiosConfig'
  import { TOKEN_ID } from '@/mutation/mutConst'
  import {MESSAGE_DURATION } from  '@/api/constant'
    export default {
      name : 'mini_head_top',
    	data(){
    		return {
          logo,
          userInfo:{
          fullName :'',
          userName :'',
          imageUrl:''
        }
    		}
    	},
      methods: {
        getUserInfo(){
          let url = "/bc/exa/usr/getUsrInfo"
          let dat0 = {
          }
          axios.post(url, dat0).then((response) => {
              if (response.data.code === 0) {
                let dat = response.data.data
                if(dat!= null && dat != ''){
                  this.userInfo.fullName = dat.fullName
                  this.userInfo.usrName = dat.usrName  
                  this.userInfo.imageUrl = dat.headImag
                } else {
                  this.$message({
                    showClose: true,
                    message: '未查询到规章制度信息！',
                    type: 'info',
                    duration: MESSAGE_DURATION
                  })
                }
              }else{
                this.$message({
                  showClose: true,
                  message: response.data.message,
                  type: 'error',
                  duration: MESSAGE_DURATION
                })
              }
              }).catch((err)=>{
                this.$message({
                  showClose: true,
                  message: err.message,
                  type: 'error',
                  duration: MESSAGE_DURATION
                })
              });
        },
        doLogout(){
          let dat = {}
          let url = "/bc/exa/usr/logout"
          let s = JSON.stringify(dat)  
          axios.post(url, s).then((response) => {
            if (response.data.code === 0){
              this.$store.commit(TOKEN_ID, '')
              this.$router.push({path :'/mini_login'})
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
          }).catch( (err) => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
          })
        },
		  },
      created(){
        setTimeout(()=>{this.getUserInfo()},200)
      }
    }
</script>

<style lang="less">
	.grid-content{
    margin-top: 4px;
    margin-left: 1px;
    text-align: center;
    font-weight: 700;
    color: #0162c3 ;
    font-size: 0.8em;
  }
</style>



// WEBPACK FOOTER //
// src/mini_pages/mini_head_top.vue